<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">Video Templates</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Integrate</span>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <div v-if="$route.params.integration === 'hubspot'">
          <h3>Integrate into HubSpot sequence</h3>

          <p>Highlight and copy this image into the HubSpot sequence email editor. Please wait a few seconds for it to load.</p>
          <b-card>

            <div v-bind:key="'with_website'" v-if="include_website">
              <a :href='`https://${config.firebase_config.video_domain}/v1/${item.id}?name={{contact.firstname}}&website={{contact.email}}`'>
                <img :src='`https://${config.firebase_config.video_domain}/v1/${item.id}/thumbnail?name={{contact.firstname}}&website={{contact.email}}&email={{contact.email}}`' width='480' height="360" alt='Click here to watch video'/>
              </a>
            </div>

            <div v-bind:key="'without_website'" v-else>
              <a :href='`https://${config.firebase_config.video_domain}/v1/${item.id}?name={{contact.firstname}}`'>
                test
                <img :src='`https://${config.firebase_config.video_domain}/v1/${item.id}/thumbnail?name={{contact.firstname}}&email={{contact.email}}`' width='480' height="360" alt='Click here to watch video'/>
              </a>
            </div>

            <template #footer>
              <b-button @click="copy_html_to_clipboard(code)" size="sm" class='d-inline-block'>Copy to clipboard</b-button>

              <b-form-checkbox v-model="include_website" switch class="ml-4 d-inline-block">
                Use their website as background
              </b-form-checkbox>
            </template>
          </b-card>
        </div>

        <div v-else-if="$route.params.integration === 'linkedin_automation'">
          <h3>Integrate into LinkedIn Automation</h3>

          <p>Vidon works with LinkedIn automation tools like octopus or Dux-Soup. But can also be used manually in LinkedIn messenger</p>

          <p>Copy and paste the following link into the message editor. Replace <code>REPLACE</code> with the first name and website variables e.g. <code>{{variables.mixmax.first_name}}</code> recipients first name. It will show a preview image of the video in LinkedIn.</p>
          <b-card>
            <pre class="mb-0">{{code}}</pre>

            <template #footer>
              <b-button v-clipboard:copy="code" v-clipboard:success="copy_success" size="sm" class='d-inline-block'>Copy to clipboard</b-button>

              <b-form-checkbox v-model="include_website" switch class="ml-4 d-inline-block">
                Use their website as background
              </b-form-checkbox>
            </template>
          </b-card>

        </div>

        <div v-else>
          <h3>Integrate into {{variables[$route.params.integration].name}}</h3>

          <p>Copy and paste the following into the HTML editor of your email</p>

          <b-card>
            <pre class="mb-0">{{code}}</pre>

            <template #footer>
              <b-button v-clipboard:copy="code" v-clipboard:success="copy_success" size="sm" class='d-inline-block'>Copy to clipboard</b-button>

              <b-form-checkbox v-model="include_website" switch class="ml-4 d-inline-block">
                Use their website as background
              </b-form-checkbox>
            </template>
          </b-card>
        </div>

        <h4>Need help?</h4>
        Please read <a href='https://support.vidon.ai/integrations' target='_blank'>the tutorial on how to integrate</a>.

      </div>
    </b-card>
  </b-container>
</template>

<script>
import { db, config } from '@/main.js'

export default {
  metaInfo: {title: 'Video integration'},
  props: ['integration', 'from_item'],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id),
    }
  },
  data() {
    return {
      collection: 'project',
      item: this.from_item,
      include_website: true,
      variables: {
        reply: {
          name: 'Reply.io',
          first_name: '{{FirstName}}',
          website: '{{Email}}',
          email: '{{Email}}'
        },
        'prospect.io': {
          name: 'Prospect.io',
          first_name: '{{prospect_firstname}}',
          website: '{{prospect_email}}',
          email: '{{prospect_email}}'
        },
        salesloft: { // https://support.salesloft.com/hc/en-us/articles/360027742311-Available-Dynamic-Fields
          name: 'SalesLoft',
          first_name: '{{first_name}}',
          website: '{{email_address}}',
          email: '{{email_address}}'
        },
        'outreach.io': { // https://support.outreach.io/hc/en-us/articles/226680368-Variables-Overview
          name: 'Outreach.io',
          first_name: '{{first_name}}',
          website: '{{email}}', // OR '{{website}}'
          email: '{{email}}'
        },
        'close.io': { // https://help.close.com/docs/sending-receiving-email
          name: 'Close.io',
          first_name: '{{contact.first_name}}',
          website: '{{contact.primary_email.email}}',
          email: '{{contact.primary_email.email}}'
        },
        persistIQ: { // https://help.persistiq.com/en/articles/1833241-sender-variables
          name: 'PersistIQ',
          first_name: '{{first_name}}',
          website: '{{email}}',
          email: '{{email}}'
        },
        salesforce: {
          name: 'Salesforce',
          first_name: '{{{Recipient.FirstName}}}',
          website: '{{{Recipient.Email}}}',
          email: '{{{Recipient.Email}}}'
        },
        mixmax: { // https://success.mixmax.com/article/147-template-variables
          name: 'MixMax',
          first_name: '{{first name}}',
          website: '{{email}}',
          email: '{{email}}'
        },
        other: {
          name: 'Other email',
          first_name: 'REPLACE',
          website: 'REPLACE',
          email: 'REPLACE'
        },
        undefined: {
          name: 'Other email',
          first_name: 'REPLACE',
          website: 'REPLACE',
          email: 'REPLACE'
        }
      }
    }
  },
  methods: {
    link_url(variables) {
      if (this.include_website) {
        return `<a href="https://${config.firebase_config.video_domain}/v1/${this.item.id}?name=${variables.first_name}&website=${variables.website}&email=${variables.email}" target="_blank">`
      } else {
        return `<a href="https://${config.firebase_config.video_domain}/v1/${this.item.id}?name=${variables.first_name}&email=${variables.email}" target="_blank">`
      }
    },
    thumbnail_url(variables) {
      if (this.include_website) {
        return `<img src="https://${config.firebase_config.video_domain}/v1/${this.item.id}/thumbnail?name=${variables.first_name}&website=${variables.website}&email=${variables.email}" alt="Click to watch video" width="480" height="360" />`
      } else {
        return `<img src="https://${config.firebase_config.video_domain}/v1/${this.item.id}/thumbnail?name=${variables.first_name}&email=${variables.email}" alt="Click to watch video" width="480" height="360" />`
      }
    },
    copy_success() {
      this.$swal({title: 'Copied', text: 'Copied to clipboard', icon: 'success'})
    },
    copy_html_to_clipboard(str) {
      function listener(e) {
        e.clipboardData.setData("text/html", str);
        e.clipboardData.setData("text/plain", str);
        e.preventDefault();
      }
      document.addEventListener("copy", listener);
      document.execCommand("copy");
      document.removeEventListener("copy", listener);

      this.copy_success()
    },
  },
  computed: {
    code() {
      if (this.$route.params.integration === 'linkedin_automation') {
        if (this.include_website) {
          return `https://${config.firebase_config.video_domain}/v1/${this.item.id}?name=REPLACE&website=REPLACE`
        } else {
          return `https://${config.firebase_config.video_domain}/v1/${this.item.id}?name=REPLACE`
        }
      }

      if (this.$route.params.integration === 'hubspot') {
        if (this.include_website) {
          return `<a href='https://${config.firebase_config.video_domain}/v1/${this.item.id}?name={{contact.firstname}}&website={{contact.email}}&email={{contact.email}}'><img src='https://${config.firebase_config.video_domain}/v1/${this.item.id}/thumbnail?name={{contact.firstname}}&website={{contact.email}}&email={{contact.email}}' width='480' height="360" alt='Click here to watch video'/></a>`
        } else {
          return `<a href='https://${config.firebase_config.video_domain}/v1/${this.item.id}?name={{contact.firstname}}&email={{contact.email}}'><img src='https://${config.firebase_config.video_domain}/v1/${this.item.id}/thumbnail?name={{contact.firstname}}&email={{contact.email}}' width='480' height="360" alt='Click here to watch video'/></a>`
        }
      }

      let variables = this.variables[this.$route.params.integration]
      return `${this.link_url(variables)}\n  ${this.thumbnail_url(variables)}\n</a>`
    },
  }
}
</script>

<style>

</style>
